import { render, staticRenderFns } from "./BranchCodeList.vue?vue&type=template&id=0c6bd1a0"
import script from "./BranchCodeList.vue?vue&type=script&lang=js"
export * from "./BranchCodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports